export const GET_ADS_BY_SIZE_INIT = "GET_ADS_BY_SIZE_INIT";
export const GET_ADS_BY_SIZE_SUCCESS = "GET_ADS_BY_SIZE_SUCCESS";
export const GET_ADS_BY_SIZE_FAILED = "GET_ADS_BY_SIZE_FAILED";